import { Component, OnInit, HostListener, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LoginTypes, defaultLanguage } from '../../constant';

/**
 * import services
 */
import { LoginService } from '../services/login.service';
import { CookieManagerService, ErrorManagerService, HttpClientService, BasicTimerService, emailValidator, isValidEmailOrMobile, mobileValidator, emptyField, usernameValidator, matchingPasswords, GoogleService, isValidEmail } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { CookieNames, AuthTypes, BasicRoutes, ErrorCodes, ApiEndpoints, AlertMessages } from '../../constant';
import { ComponentCanDeactivate } from '../../login/services/route-deactivate';
import { User, NewUser } from '../../model'
import { LocalStorageService } from 'angular-2-local-storage';

import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: '../views/login-selection.component.html',
  styleUrls: ['../../../css/login-selection.component.css'],
  providers: [GoogleService]
})
export class LoginSelectionComponent implements OnInit {

  public isFinilize: boolean = true;
  public loginFormValidator: FormGroup;
  public regFormValidator: FormGroup;
  public registrationForm: FormGroup;
  /**
   * Map user object to the user model
   */
  public newUser: User = new User();
  public regUser: NewUser = new NewUser({});
  public authTypes: any = AuthTypes;
  public defoltLanguage: string = 'en';
  public formTogel: boolean = false;
  public fieldDisable: boolean = false;
  public attempt: number = 0;
  public apiRequstWaiter: boolean = true;
  public body: any;
  //private districts: Array<Object> = [];



  constructor(
    private httpClientService: HttpClientService,
    private loginService: LoginService,
    private toastr: ToastsManager,
    private route: ActivatedRoute,
    private cookieManagerService: CookieManagerService,
    private translateService: TranslateService,
    private ErrorManagerService: ErrorManagerService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private BasicTimerService: BasicTimerService,
    login: FormBuilder,
    registration: FormBuilder,
    public fb: FormBuilder,
    private googleService: GoogleService
  ) {
    this.loginFormValidator = login.group({
      'email': [null, Validators.compose([Validators.required, usernameValidator])],
      'password': [null, Validators.compose([Validators.required, Validators.minLength(6)])],
    });

    this.registrationForm = fb.group({
      username: ['', Validators.compose([Validators.required, usernameValidator])],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      firstName: ['', Validators.compose([Validators.required, emptyField])],
      lastName: ['', Validators.compose([Validators.required, emptyField])]
    }, { validator: matchingPasswords('password', 'confirmPassword') })
  }

  /**
   * Keep the user as the loged in
   */
  login(event) {
    this.googleService.emitEvent("Login", "LoginAction", this.newUser.email, 1);
    //event.preventDefault();
    this.apiRequstWaiter = false
    this.loginService.login(this.newUser).subscribe(user => {
      this.apiRequstWaiter = true
      this.loginUser(user);
      this.loginFormValidator.reset();
    }, error => {
      this.apiRequstWaiter = true
      if(error && error.json().code == 4034){
        this.sendMobileToken(true);
      }

      if (error.json().code == 4018) {
        this.forgetPassword(false);
      } else {
        this.ErrorManagerService.loginError(error.json());
      }

    });
  }

  loginUser(user: User) {
    this.cookieManagerService.setCookie(CookieNames.loginType, LoginTypes.web , false, 1);
    this.localStorageService.set(CookieNames.loginType, LoginTypes.web);
    this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify({
      firstname: user.username
    }), false, 1);
    this.cookieManagerService.setCookie(CookieNames.points, user.points, false, 1);
    this.cookieManagerService.setCookie(CookieNames.district, JSON.stringify({
      isDistrictNeed: user.isDistrictNeed
    }), false, 1);
    this.localStorageService.set(CookieNames.userImage, user.image);
    this.cookieManagerService.setCookie(CookieNames.username, user.username, false, 1);
    let selectedUser = new User(user);
    this.cookieManagerService.setCookie(CookieNames.name, selectedUser.getDisplayName(), false, 1);

    this.cookieManagerService.setCookie(CookieNames.loginKey, AuthTypes.tokenPrefix + user.token, false, 1);
    this.router.navigate([BasicRoutes.clientExams]);
  }
  /**
   * Register user
   */
  register() {
    this.googleService.emitEvent("SignUp", "SignUp", this.regUser.email, 1);
    this.apiRequstWaiter = false
    this.loginService.register(this.regUser).subscribe(res => {
      this.apiRequstWaiter = true;
      if (res && res.type == 'MOBILE') {
        this.sendMobileToken(false);
      }
      if (res && res.type == 'EMAIL') {
        this.regUser = new NewUser({});
        this.successfulyRegisterd();
        this.loginForm();
        this.registrationForm.reset();
      }

    }, error => {
      this.apiRequstWaiter = true;
      if (error.json().verified !== undefined && !error.json().verified || error.json().code == 4034) {
         this.sendMobileToken(false);
        return;
      }
      if (error && error.type == 'EMAIL' && error.json().code == 4018) {
        this.forgetPassword(false);
        return;
      }
      this.ErrorManagerService.loginError(error.json());

    });
  }
  /**
   * TOgle to reg form
   */
  registerForm() {
    this.loginFormValidator.reset();
    this.formTogel = true;
    this.regUser = new NewUser({});
  }

  /**
   * Login form
   */
  loginForm() {
    this.registrationForm.reset();
    this.formTogel = false;
  }


  /**
   * Validate Password when user typing
   */
  validatePassword() {

    let password = this.regUser.password;
    let repertPassword = this.regUser.reenterpassword;
    if (repertPassword) {
      if (password === repertPassword || repertPassword === password) {
        this.fieldDisable = false;
      } else {
        this.fieldDisable = true;
      }
    }

  }

  //let type = ApiEndpoints.getTokenAgain  ApiEndpoints.forgetPassword

  forgetPassword(type) {
    let service = this.httpClientService;
    let message = this.translateService;
    swal({ 
      title: type ? message.instant('FORGET_PASSWORD') : message.instant('EMAIL_NOT_YET_VERIFY_TITLE'),
      text: type ? message.instant('FORGET_PASSWORD_TITLE') : message.instant('EMAIL_NOT_YET_VERIFY'),
      input: 'text',
      inputClass: 'glyphicon',
      inputPlaceholder: message.instant('EMAIL_ADDRESS_OR_MOBILE_NUMBER'),
      showCancelButton: true,
      customClass: type ? '' : 'custada',
      confirmButtonClass: 'swal2-confirm-left',
      confirmButtonText: message.instant('GET_VERIFY_EMAIL'),
      cancelButtonText: message.instant('BTN_SKIP'),
      confirmButtonColor: '#5cb85c',
      showLoaderOnConfirm: true,
      preConfirm: (email) => {
        return new Promise((resolve, reject) => {
          if (isValidEmailOrMobile(email)) {
            reject(message.instant('EMAIL_REQURED'))
            return;
          }
          service.post(type ? ApiEndpoints.forgetPassword : ApiEndpoints.getTokenAgain, { email: email }).subscribe(response => {
            resolve();
            this.googleService.emitEvent("ForgetPassword", "ForgetPassword", email, 1);
          }, error => {
            if (error.json().code == ErrorCodes.NO_USER_ACCONT.CODE) {
              reject(message.instant('NO_USER_ACCOUNT'))
              return;
            }
            if (error.json().code == ErrorCodes.FACEBOOK_USER.CODE) {
              reject(message.instant('FACEBOOK_USER'));
              return;
            }
            reject(message.instant('EMAIL_SENT_ERROR'));
          });
        })
      },
      allowOutsideClick: true
    }).then(function (email) {
      
      swal({
        title: message.instant('EMAIL_SENT'),
        html: email + (!isValidEmail(email) ? message.instant('FORGET_EMAIL_HASE_BEEN_SENT') : message.instant('FORGET_SMS_HASE_BEEN_SENT')),
        confirmButtonText: message.instant('SW_MESSAGE1'),
      })
    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        return;
      }
    });
  }

  resendToken() {
    let that = this;
    swal.queue([{
      title: this.translateService.instant('VERIFIED_CODE_PROBLEM'),
      confirmButtonText: this.translateService.instant('BTN_CONFIRM'),
      text: this.translateService.instant('GET_SMS_CODE_AGAIN'),
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.httpClientService.post(ApiEndpoints.resendmobiletoken, { mobile: that.regUser.email ? that.regUser.email :  that.newUser.email}).subscribe(response => {
            that.sendMobileToken(false);
          }, error => {
            reject('කේත තහවුරු කිරීමේ දෝෂයක්');
          });
          resolve();
        })
      }
    }]).then(function () {

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        return;
      }
    });
  }

  sendMobileToken(type) {
    let that = this;
    let service = this.httpClientService;
    let message = this.translateService;
    swal({
      title: type ? message.instant('THIS_MOBILE_NUMBER_NOT_VERIFIED_YET') : message.instant('ENETR_MOBILE_TOKEN'),
      text: message.instant('ENTER_MOBILE_TOKEN_DISCRIPTION'),
      input: 'text',
      inputClass: 'glyphicon',
      inputPlaceholder: message.instant('ENTER_TOKEN'),
      showCancelButton: true,
      customClass: 'sms_mobile_input',
      confirmButtonClass: 'swal2-confirm-left',
      confirmButtonText: message.instant('BTN_CONFIRM'),
      cancelButtonText: message.instant('GET_VERIFY_EMAIL'),
      confirmButtonColor: '#5cb85c',
      showLoaderOnConfirm: true,
      preConfirm: (number) => {
        return new Promise((resolve, reject) => {
          if (!number) {
            reject(message.instant('PUT_A_NUMBER'))
            return;
          }
          service.post(ApiEndpoints.verifymobiletoken, { token: number, mobile: that.regUser.email }).subscribe(response => {
            resolve(response);
          }, error => {
            reject(message.instant('GET_NEW_MOBILE_TOKEN'));
            return;
          });
        })
      },
      allowOutsideClick: false
    // }).then(function (user: any, fn) {
    }).then(function (user: any) {
      that.loginUser(user);
    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        that.resendToken();
      }
    });
  }

  successfulyRegisterd() {
    let message = this.translateService;
    swal({
        title: message.instant('REGISTRATION_SUCCESS'),
        text: message.instant('EMAIL_NOT_YET_VERIFY_TITLE'),
        confirmButtonText: message.instant('SW_MESSAGE1'),
      }
    )
  this.googleService.emitEvent("Resgistor", "ResgistorButtonAction", "RegisterLog", 1);
  }

  loginError() {
    this.ErrorManagerService.loginError({ code: '1000' });
  }

  RegistationError() {
    this.ErrorManagerService.loginError({ code: '999' });
  }

  ngOnInit() {

    if (this.cookieManagerService.getCookie(CookieNames.loginKey, false)) {
      this.router.navigate([BasicRoutes.clientExams]);
    }

    this.route.params.forEach((params: Params) => {
      if (params['register'] == 'register') {
        this.registerForm();
      } else {
        this.loginForm();
      }
    });

    this.body = document.getElementsByTagName('body')[0];
    this.body.classList.add("login-rm-ovlw");
    // this.translateService.use(this.defoltLanguage);
    var language = this.cookieManagerService.getCookie("Lang", false);
    this.translateService.use(language ? language : defaultLanguage);

    //this.loadDistricts();
  }

  ngOnDestroy() {
    this.body.classList.remove("login-rm-ovlw");
  }

  // loadDistricts() {
  //   this.httpClientService.get(ApiEndpoints.getDistricts).subscribe(response => {
  //       this.districts = response;
  //   }, error => {

  //   });
  // }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/components/login-selection.component.ts